































import { Component, Prop, Vue } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import i18next from 'i18next';

@Component({
  components: { NewTranslation, Button },
})
export default class TicketSelectPage extends Vue {
  @Prop({ type: Object, required: false })
  public transaction!: any | null;

  @Prop(Boolean)
  public showWarning!: boolean;

  @Prop({ type: Number, default: 0 })
  public maxSelection!: number;

  selectedIds: number[] = [];

  created() {
    this.selectAll();
  }

  public get selectableTaxcards(): any[] {
    return this.transaction.taxcards;
  }

  public get maxAmountReached() {
    return this.maxSelection > 0 && this.selectedIds.length >= this.maxSelection;
  }

  public onConfirm() {
    this.$emit('select', this.selectedIds);
  }

  public onToggleTaxcard(id: number) {
    const index = this.selectedIds.indexOf(id);
    if (index > -1) {
      this.selectedIds.splice(index, 1);
    } else {
      this.selectedIds.push(id);
    }
    if (this.maxAmountReached) {
      this.showLimitWarning();
      return;
    }
  }

  public showLimitWarning() {
    this.$store.commit('openOverlay', {
      overlayName: 'Info',
      overlayData: {
        title: i18next.t('ticketSelect.limitReached.title'),
        message: i18next.t('ticketSelect.limitReached.body', { count: this.maxSelection }),
      },
    });
  }

  public selectAll() {
    if (this.maxSelection !== 0 && this.selectableTaxcards.length > this.maxSelection) {
      this.selectedIds = this.selectableTaxcards.slice(0, this.maxSelection).map(taxcard => taxcard.id);
    } else {
      this.selectedIds = this.selectableTaxcards.map(taxcard => taxcard.id);
    }
  }
}
